import React,{useState, createContext, useContext, useRef, useEffect} from "react";
import { UserContext } from "./UserContext";
import { ConquerContext } from "./ConquerContext";
import { ACTIONS } from "../../Models/ENUM";
import ChatVideocall from "../screens/Chat/Videocall/ChatVideocall";
import useCallStatus from "../hooks/useCallStatus";
import { ROOM_CALL_STATE } from "../../Conquer/ROOMS/RoomInstance/RoomInstance";
import RoomPeer from "../../Conquer/ROOMS/RoomInstance/RoomPeer";

export const ChatContext = createContext();

const ChatContextProvider = ({ roomKeys, isPersistent = false, isLoadingCallback, children }) => {

    const conquer = useContext( ConquerContext );
    const userContext = useContext( UserContext );
    
    const [ roomInstance, setRoomInstance ] = useState( false );
    const [ messages, setMessages ] = useState( [] );
    const [ avatars, setAvatars ] = useState( {} );
    const [isOnCall, setIsOnCall] = useState( false );
    const [peer, setPeer] = useState( false );
    const [rivalID, setRivalID] = useState( false );

    const messagesRef = useRef();
    const roomRef = useRef();
    const peerRef = useRef();
    messagesRef.current = messages;
    roomRef.current = roomInstance;

    const callStatus = useCallStatus( roomRef.current, peerRef.current );

    function tryToLoadRoom() {

        setMessages([]);

        async function doWork(){

            if( (!userContext.userData.isLogged && isPersistent) || !roomKeys ){
                if( roomInstance ){
                    setRoomInstance( false );
                    // setPeer( false );
                }
                return;
            }
            
            isLoadingCallback?.(true);
            let room = await conquer.Rooms.getOne( roomKeys );
            isLoadingCallback?.(false);
            room.isGroup = !Array.isArray( roomKeys );

            setRoomInstance( room );
            if( room.error ) return false;
            
            await room.join();

            room.onMessage = onMessageReceived;
            room.onJoin = onPlayerJoin;

            if( !room.isGroup ){

                let totalAvatars = {};

                if( room.avatarIDs ){
                    for( const eachAvatar of room.avatarIDs ){
                        if( eachAvatar != conquer.User.avatarID ) setRivalID(eachAvatar);
                        let friendAvatar = await conquer.Avatars.get( eachAvatar );
                        totalAvatars[friendAvatar.avatarID] = friendAvatar;
                    }    
                }
    
                setAvatars( totalAvatars );

            }

            if( isPersistent ){

                let storedMessages = await room.Entries.get();
                setMessages( storedMessages.reverse() );

            }

        }
        doWork();

    }
    useEffect(tryToLoadRoom, [roomKeys, userContext.userData.isLogged]);

    useEffect( () => {
        setIsOnCall( callStatus == ROOM_CALL_STATE.IN_PROGRESS );
    }, [ callStatus ]);

    useEffect( () => {

        if( !userContext.userData.isLogged ){
            if( peerRef.current ) peerRef.current.disconnect();
            return setPeer( false );
        }

        if( !peerRef.current ){
            let newPeer = new RoomPeer( conquer);
            setPeer( newPeer );
            peerRef.current = newPeer;
        }

        if( roomRef.current ) peerRef.current.assignRoom( roomRef.current );

    }, [ userContext.userData.isLogged, roomInstance ]);


    function onMessageReceived( message, metadata ){


        if( roomRef.current.isGroup && message.action == ACTIONS.GAMEDATA ) return updatePlayers( message );
            
        if( typeof message == 'string' ) message = {
            action: ACTIONS.CHAT,
            text: message,
            metadata,
            avatarID: conquer.User.avatarID
        };
            
        if( message.action == ACTIONS.PLAYERJOIN && peerRef.current) setTimeout( () => { peerRef.current.startConnection();} , 2000 );

        if( !message.timestamp && (!message.data || !message.data.timestamp) ) message.timestamp = Date.now();

        if( message.action != ACTIONS.CHAT ) return;



        let newMessages = [...messagesRef.current];
        newMessages.unshift( message );
        setMessages( newMessages );

        roomInstance.onMessage = onMessageReceived;

    }


    function onPlayerJoin(){

        if( !peerRef.current || peerRef.current.isCreated || !isPersistent ) return;

        peerRef.current.createConnection();

    }

    useEffect( () => {

        if( roomInstance.peer ) setIsOnCall( roomInstance.peer.isOnCall );

    }, [(roomInstance.peer || {}).isOnCall]);

    function updatePlayers( gameData ){

        let totalAvatars = gameData.data.online;
        setAvatars( totalAvatars );

    }

    async function sendMessage( text, metadata ){

        await isPersistent ? roomRef.current.entry( text, metadata ) : roomRef.current.chat(text);
        onMessageReceived( text, metadata );
        

    }

    function getTargetAvatar(){

        
        for( const eachFriend of Object.values(avatars) ){
            if( eachFriend.avatarID == userContext.userData.avatarID ) continue;
            return eachFriend;
        }

        return {};

    }

    if( !roomKeys ) return <></>;

    return  <ChatContext.Provider
                    value={{ roomInstance, setRoomInstance, isPersistent, avatars, messages, sendMessage, getTargetAvatar, peer: peerRef.current }}>
                        {isOnCall && <ChatVideocall peer={peer} roomInstance={roomInstance} getTargetAvatar={getTargetAvatar}/>}
                        {children}
                </ChatContext.Provider>
};

export default ChatContextProvider;
